import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useI18n } from "../i18n";
import { openPreferences } from "../consent";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { lang, t } = useI18n();
  const base = `/${lang}`;
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container site-footer__grid">
        <div className="site-footer__brand">
          <Logo />
          <p className="site-footer__tagline">{t("footer.tagline")}</p>
          <ul className="site-footer__contact">
            <li>
              <MapPin size={16} aria-hidden="true" />
              <span>{t("footer.address")}</span>
            </li>
            <li>
              <Phone size={16} aria-hidden="true" />
              <a href={`tel:${t("footer.phone").replace(/\s|\+/g, "")}`}>{t("footer.phone")}</a>
            </li>
            <li>
              <Mail size={16} aria-hidden="true" />
              <a href={`mailto:${t("footer.emailAddress")}`}>{t("footer.emailAddress")}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4>{t("footer.company")}</h4>
          <ul className="site-footer__list">
            <li><Link to={base}>{t("nav.home")}</Link></li>
            <li><a href={`${base}#overview`}>{t("nav.overview")}</a></li>
            <li><a href={`${base}#process`}>{t("nav.process")}</a></li>
            <li><a href={`${base}#transparency`}>{t("nav.transparency")}</a></li>
          </ul>
        </div>

        <div>
          <h4>{t("footer.legal")}</h4>
          <ul className="site-footer__list">
            <li><Link to={`${base}/privacy`}>{t("nav.privacy")}</Link></li>
            <li><Link to={`${base}/cookies`}>{t("nav.cookies")}</Link></li>
            <li><Link to={`${base}/terms`}>{t("nav.terms")}</Link></li>
            <li>
              <button type="button" className="site-footer__linkbtn" onClick={openPreferences} data-testid="footer-cookie-prefs">
                {t("footer.cookiePrefs")}
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4>{t("footer.contact")}</h4>
          <ul className="site-footer__list">
            <li><a href={`${base}#contact`}>{t("contact.title")}</a></li>
            <li><a href={`mailto:${t("footer.emailAddress")}`}>{t("footer.emailLabel")}</a></li>
          </ul>
        </div>
      </div>

      <div className="container site-footer__legal">
        <p>
          © {year} · {t("footer.registered")} · {t("footer.cuit")}
        </p>
        <p>{t("footer.iigj")}</p>
        <p>{t("footer.cnv")}</p>
        <p>{t("footer.license")}</p>
        <p>{t("footer.jurisdiction")} · {t("footer.incorporated")}</p>
        <p className="site-footer__disclaimer">{t("footer.disclaimer")}</p>
        <p>{t("footer.rights")}</p>
      </div>
    </footer>
  );
}
